// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 4955) return "static/chunks/4955-98a004a7a8b536d5.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7642 ? "94a7ad86" : chunkId) + "." + {"551":"007c1918cdd2e42b","2692":"2624c4065a186984","2936":"f66efa84a59f2b4b","3252":"65de05daf9215615","6934":"e7c1bc4154042ff1","7642":"3f011836de9541b9","7680":"b8e058d0bf58b84b","8470":"1c6d3b8a2a4ad64e","9879":"32b19b4526f44777"}[chunkId] + ".js";
};